// Mirrors `.wf-input-wrap .form-control` in App.css so the encrypted MUI
// fields (SSN / phone / other) sit alongside the plain bootstrap inputs
// without looking like a different control. The label is rendered above by
// the caller, so these fields use a placeholder rather than a floating label.
const bprmFieldSx = {
  "& .MuiOutlinedInput-root": {
    borderRadius: 0,
    height: "38px !important",
    minHeight: "38px !important",
    maxHeight: "38px !important",
    boxSizing: "border-box !important",
    backgroundColor: "#ffffff",
    boxShadow: "none",
    transition: "all 0.2s cubic-bezier(0.4, 0, 0.2, 1)",
    paddingRight: "8px",
    "& fieldset": {
      borderColor: "#cbd5e1",
      borderWidth: "1.5px",
    },
    "&:hover fieldset": {
      borderColor: "#94a3b8",
    },
    "&.Mui-focused": {
      backgroundColor: "#ffffff",
      boxShadow: "0 0 0 3px rgba(37, 99, 235, 0.12)",
    },
    "&.Mui-focused fieldset": {
      borderColor: "#2563eb",
      borderWidth: "1.5px",
    },
    "&.Mui-disabled": {
      backgroundColor: "#f8fafc !important",
      cursor: "not-allowed",
      boxShadow: "none",
    },
    "&.Mui-disabled fieldset": {
      borderColor: "#cbd5e1 !important",
    },
  },
  "& .MuiOutlinedInput-input": {
    padding: "0 13px",
    fontSize: "13px",
    fontFamily: "Inter, -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, sans-serif",
    fontWeight: 400,
    color: "#1e293b",
    height: "100%",
    boxSizing: "border-box",
  },
  "& .MuiOutlinedInput-input::placeholder": {
    color: "#94a3b8",
    opacity: 1,
  },
  "& .MuiInputBase-input.Mui-disabled": {
    WebkitTextFillColor: "#1e293b !important",
    color: "#1e293b !important",
    cursor: "not-allowed",
    opacity: 1,
  },
  "& .MuiInputLabel-root.Mui-disabled": {
    color: "#1e293b !important",
    opacity: 1,
  },
  "& .MuiFormHelperText-root": {
    fontSize: "12px",
    fontFamily: "Inter, -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, sans-serif",
  },
  // Reveal / calendar adornment buttons. The explicit outline reset is load
  // bearing: a global button:focus rule otherwise draws a dark ring here.
  "& .MuiInputAdornment-root": {
    marginLeft: "2px",
  },
  // edge="end" ships a -12px right margin to sit flush with the border; the
  // input's own paddingRight supplies the gap instead.
  "& .MuiInputAdornment-root .MuiIconButton-edgeEnd": {
    marginRight: 0,
  },
  "& .MuiInputAdornment-root .MuiIconButton-root": {
    padding: "5px",
    borderRadius: "7px",
    color: "#94a3b8",
    transition: "color 0.2s ease, background-color 0.2s ease",
    outline: "none",
    boxShadow: "none",
    "& svg": {
      fontSize: "17px",
    },
    "&:hover": {
      backgroundColor: "rgba(37, 99, 235, 0.08)",
      color: "#2563eb",
    },
    "&:focus, &:focus-visible, &:active": {
      outline: "none",
      boxShadow: "none",
    },
    "&.Mui-disabled": {
      color: "#cbd5e1",
    },
  },
  // Only the "hide" button (rendered while the value is exposed) keeps a
  // colour, so a revealed SSN still reads as something to put back.
  "& .MuiInputAdornment-root .MuiIconButton-colorError": {
    color: "#dc2626",
    "&:hover": {
      backgroundColor: "rgba(220, 38, 38, 0.1)",
      color: "#b91c1c",
    },
  },
};

export default bprmFieldSx;
